import { render, staticRenderFns } from "./zygczb.vue?vue&type=template&id=1e0944f5&"
import script from "./zygczb.vue?vue&type=script&lang=ts&"
export * from "./zygczb.vue?vue&type=script&lang=ts&"
import style0 from "./zygczb.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports